import { useTranslation } from "react-i18next"

import { AuthenticatedPageLayout } from "@/components/authenticated-page-layout"
import { DataGuard } from "@/components/data-guard"
import { SigmaReport } from "@/components/sigma-report"
import {
  SigmaWorkbookId,
  allFinancialWorkspaceName,
  useSigmaWorkbooks,
} from "@/services/sigma"
import type { SigmaWorkbook } from "@/services/sigma"

export const FinancialOverview = () => {
  const { t } = useTranslation()
  const { sigmaWorkbooksData } = useSigmaWorkbooks({
    apiOptions: {
      workspaceNames: [allFinancialWorkspaceName],
    },
  })

  const financialOverviewWorkbook: SigmaWorkbook | undefined =
    sigmaWorkbooksData?.entries.find(
      (workbook) =>
        (workbook.workbookId as SigmaWorkbookId) ===
        SigmaWorkbookId.FinancialOverview
    )

  return (
    <AuthenticatedPageLayout
      fullHeight
      title={t("moduleTitle.financial", { ns: "common" })}
    >
      <DataGuard>
        <SigmaReport
          reportTitle={t("moduleTitle.financial", { ns: "common" })}
          workbookId={financialOverviewWorkbook?.workbookId}
        />
      </DataGuard>
    </AuthenticatedPageLayout>
  )
}
